import React from 'react';
import { useSelector } from 'react-redux';
import { TitleTypography } from 'components/Ui/styled';
import { ListItemWrap, StatusDot } from '../dashboardStyled';
import { cardListColors, NO_SESSIONS_TEXT } from 'constants';
import { useRenderNoInfo, formatDateUTCString } from 'utils/commonUtils';

const DashboardTutoringSessions = () => {
  const tutoringSessions = useSelector(
    (state) => state.dashboard.tutoringSessions
  );

  const noInfoComponent = useRenderNoInfo(
    tutoringSessions,
    NO_SESSIONS_TEXT,
  );

  return (
    <>
      {noInfoComponent}
      {tutoringSessions?.map((item, index) => {
        const formattedDate = formatDateUTCString(item.date);
        const title = `${item.subjectName} ( Date: ${formattedDate}, Start Time: ${item.startTimeFmt} )`;
        const dotColor = cardListColors[index % cardListColors.length];

        return (
          <ListItemWrap key={index}>
            <StatusDot bgcolor={dotColor} />
            <TitleTypography>{title}</TitleTypography>
          </ListItemWrap>
        );
      })}
    </>
  );
};

export default DashboardTutoringSessions;
